const toCurrency = (
  value = 0,
  {
    style = "currency",
    currency = "USD",
    maximumFractionDigits = 0,
    minimumFractionDigits = 0,
  } = {}
) => {
  return new Intl.NumberFormat("en-US", {
    style,
    currency,
    maximumFractionDigits,
    minimumFractionDigits,
  }).format(value);
};

export default toCurrency;
